export class DynFormSectionBase {

    id!: number;
    name!: string;
    template!: boolean;
    required!: boolean;
    type!: number; // DynFormSectionType //
    order!: number;

    dynFormId!: number;


    static from(dynFormSection: DynFormSection): DynFormSectionBase {
        let current = new DynFormSectionBase()
        Object.assign(current, dynFormSection)
        return current
    }

    static sortFn(a: DynFormSectionBase, b: DynFormSectionBase): number {
        if (a.order > b.order) return 1
        if (a.order < b.order) return -1

        return 0
    }

}

export interface DynFormSection extends DynFormSectionBase { }